import React from "react";
import cs from "classnames";
import PartnersSection from "../../organisms/PartnersSection";

const NineteenKislev = () => {
  return (
    <main className={cs("minh-100vh pt-10")}>
      <PartnersSection discount={false} />
    </main>
  );
};

export default NineteenKislev;

